import { useEffect, useState } from "react"
import useWindowDimensions from "@hooks/useWindowDimensions"
import { LAYOUT_PADDING_TOP, HEADER_HEIGHT } from "@constants"

const useHeaderConfiguration = () => {
  const { height, isDesktop, isMobile } = useWindowDimensions()
  const [currentOpacity, setCurrentOpacity] = useState(0)

  useEffect(() => {
    const scrollHandler = () => {
      const animationHeight = LAYOUT_PADDING_TOP - HEADER_HEIGHT
      const opacity = Math.round((window.scrollY / animationHeight) * 100) / 100

      setCurrentOpacity(() => (opacity >= 1 ? 1 : opacity))
    }

    document.addEventListener("scroll", scrollHandler)

    return () => document.removeEventListener("scroll", scrollHandler)
  }, [height, isDesktop])

  return {
    currentOpacity,
    isDesktop,
    isMobile
  };
}

export default useHeaderConfiguration
